export default "__VITE_ASSET__Dqaoc7yF__"